import React from 'react';

/**
 * PullToRefreshIndicator — premium gold ring spinner that slides down from the top.
 * Only renders meaningfully when pullDistance > 0 OR refreshing === true.
 */
const PullToRefreshIndicator = ({ pullDistance = 0, refreshing = false, progress = 0, threshold = 80 }) => {
  const visible = pullDistance > 0 || refreshing;
  // Map pullDistance into a translateY for the indicator's center.
  const y = refreshing ? threshold : pullDistance;
  // Ring rotation maps to pull progress before refresh starts.
  const rotation = refreshing ? 0 : progress * 270;
  const opacity = Math.min(1, pullDistance / 28);

  return (
    <div
      aria-hidden={!visible}
      className="pointer-events-none fixed left-1/2 z-[60] -translate-x-1/2 lg:hidden"
      style={{
        top: 0,
        transform: `translate3d(-50%, ${y - 40}px, 0)`,
        transition: refreshing || pullDistance === 0
          ? 'transform 360ms cubic-bezier(0.22, 1, 0.36, 1), opacity 220ms ease'
          : 'none',
        opacity: visible ? opacity : 0,
      }}
      data-testid="pull-to-refresh"
    >
      <div
        className="w-11 h-11 rounded-full bg-white/95 backdrop-blur shadow-[0_8px_24px_-8px_rgba(10,10,10,0.4),0_0_0_1px_rgba(197,160,89,0.25)] flex items-center justify-center"
      >
        {refreshing ? (
          <svg
            className="w-5 h-5 animate-spin"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#C5A059"
            strokeWidth={2.4}
            strokeLinecap="round"
          >
            <path d="M12 3a9 9 0 1 1-9 9" />
          </svg>
        ) : (
          <svg
            className="w-5 h-5"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#C5A059"
            strokeWidth={2.4}
            strokeLinecap="round"
            style={{
              transform: `rotate(${rotation}deg)`,
              transition: 'transform 120ms linear',
            }}
          >
            <path d="M12 3a9 9 0 1 1-9 9" />
            <path d={progress >= 1 ? 'M7 13l3 3 7-7' : 'M12 7v5l3 2'} />
          </svg>
        )}
      </div>
    </div>
  );
};

export default PullToRefreshIndicator;
